import { StatusCheckIcon, ProjectManagerIcon, BudgetIcon, DetailIcon, CalendarIcon, ProjectNameIcon } from 'assets';
const tableHeading = [
    {
        Icon: ProjectNameIcon,
        heading: 'Product Name'
    },
    {
        Icon: StatusCheckIcon,
        heading: 'Action'
    }
];

const tableData = [
    {
        sku: 'smsng-premium-123',
        product: 'Machine',
        category: 'Electronics',
        subCategory: 'Premium',
        brand: 'Samsung',
        quantity: 10
    },
    {
        sku: 'smsng-premium-123',
        product: 'Machine',
        category: 'Electronics',
        subCategory: 'Premium',
        brand: 'Samsung',
        quantity: 10
    },
    {
        sku: 'smsng-premium-123',
        product: 'Machine',
        category: 'Electronics',
        subCategory: 'Premium',
        brand: 'Samsung',
        quantity: 10
    }
];
const options = [
    {
        title: 'SDLC Phase 1'
    },
    {
        title: 'SDLC Phase 2'
    },
    {
        title: 'SDLC Phase 3'
    }
];
const tabs = ['Brand', 'Competible Brand', 'Competible Model', 'Category', 'Sub Category', 'Color', 'WareHouse', 'Shopify Locations', 'Shopify Products'];
const tabEnum = {
    Brand: 'Brand',
    Competible_Brand: 'Competible Brand',
    Competible_Model: 'Competible Model',
    Category: 'Category',
    SubCategory: 'Sub Category',
    Color: 'Color',
    WareHouse: 'WareHouse',
    Shopify_Locations: 'Shopify Locations',
    Shopify_Products: 'Shopify Products'
};
const optionsConfigure = [
    {
        title: 'Configure'
    },
    {
        title: 'Rename'
    },
    {
        title: 'Remove'
    }
];

export { tableHeading, tableData, options, optionsConfigure, tabs, tabEnum };
